import { Component, OnInit } from '@angular/core';
import { MenuController, ModalController, Platform } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription, timer } from 'rxjs';
import { TimelineService } from 'src/app/services/timeline.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.page.html',
  styleUrls: ['./intro.page.scss'],
})
export class IntroPage implements OnInit {

  isMale = 'true';

  maleAvatars = [];
  femaleAvatars = [];

  wwwLink: string;
  cleanSupportURL: any;
  szer: string;
  wysoko: string;
  ifrejm: any;
  startPlaying = true;
  observableVar: Subscription;
  hasChanged = false;

  constructor(private router: Router, public timelineService: TimelineService, private modalCtrl: ModalController,
              public sanitizer: DomSanitizer, public platform: Platform, public menu: MenuController) {
    this.initiatePlatformIfReady();
  }

  ngOnInit() {

    this.menu.enable(false);
    // let pikseleH;
    this.resizeAll();

    const ytLink = 'https://www.youtube.com/embed/DmhUbPkIyfc';
    this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(ytLink);

    for (let index = 1; index < 53; index++) {

      this.maleAvatars.push('assets/avatars/male/' + index + '.svg')

    }

    for (let indexF = 1; indexF < 46; indexF++) {

      this.femaleAvatars.push('assets/avatars/female/' + indexF + '.svg')

    }

    this.observableVar = timer(700).subscribe(() => {
      this.tick();
    });
    
  }

  kontynuuj(e)
  {
    // console.log('kontynuuj', this.timelineService.myName , this.timelineService.myOwnImage );
    // this.router.navigateByUrl("/kompas", {replaceUrl: false})
    this.goBackToMap();
  }

  saveAvatar(e)
  {
    // console.log("saveAvatar", this.timelineService.myOwnImage);
    this.hasChanged = true;
    this.timelineService.saveAvatar();
  }

  saveAnswer(e)
  {
    console.log("saveAnswer", this.isMale);
    this.hasChanged = true;
  }


  tick()
  {
    this.observableVar.unsubscribe();
    this.observableVar = null;
    this.resizeAll();
  }

  goBackToMap()
  {

    console.log('has changed?', this.hasChanged);
    if (this.hasChanged)
    {
      this.modalCtrl.dismiss({ avatar: this.timelineService.myOwnImage});
    }
    else
    {
      this.modalCtrl.dismiss();
    }

  }

  ngAfterViewInit()
  {
     this.ifrejm = document.getElementById('ifrejm');
     // console.log('ngAfterViewInit w', this.ifrejm.width);
  }

  getInnerWidth(elem) {

    let last = parseFloat(window.getComputedStyle(elem).width);
    if (last > 800) {last = 800;
    }

    return last;
  }

  resizeAll()
  {
    // console.log('resized', this.szer);
    this.ifrejm = document.getElementById('ifrejm');
    
    if(!this.ifrejm) 
    {
      this.wysoko = (this.getInnerWidth(window.document.body) * 0.5625) + "px"
      this.szer = this.getInnerWidth(window.document.body) + "px";
      // console.log("resizeAll XXX", this.szer);
    }
    else
    {
      this.wysoko = (this.getInnerWidth(this.ifrejm) * 0.5625) + "px"
      this.szer = this.getInnerWidth(this.ifrejm) + "px";
      // console.log("resizeAll ifrejm", this.szer);
    }
   
  }

  initiatePlatformIfReady() {
    this.platform.ready().then(() => {
      // console.log('before subscribe');

      this.platform.resize.subscribe(() => {
        
        this.resizeAll();
      });
    });
  }
}
